import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { AnalyticsService } from 'src/app/@services/analytics.service';
import { MixpanelService } from 'src/app/@services/mixpanel.service';

export function appRouteTrackingInitializer(): () => void {
  return (): void => {
    const router = inject(Router);
    const analyticsService = inject(AnalyticsService);
    const mixpanelService = inject(MixpanelService);
    const destroyRef = inject(DestroyRef);
    const documentRef = inject(DOCUMENT);
    let lastTrackedPath = '';

    router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap((event: NavigationEnd) => {
          const pagePath = event.urlAfterRedirects.split('?')[0];
          if (pagePath !== lastTrackedPath) {
            lastTrackedPath = pagePath;
            analyticsService.trackPageView(pagePath, documentRef.title);
            mixpanelService.trackPageView(pagePath, documentRef.title);
          }
        }),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe();
  };
}
